
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterFilter1On as ObiConverterFilter1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-filter-1-on.js';
 
 
 

 
 export const ObiConverterFilter1On = createComponent({
   react: React,
   tagName: 'obi-converter-filter-1-on',
   elementClass: ObiConverterFilter1OnElement,
   events: {
     
   }
  });
 
 